import { FunctionalApproval } from '@lendiodevs/lendio-js-utilities/dist/calculator/functional-approval';
import { Approval } from '@lendiodevs/lendio-js-utilities/dist/calculator/types/approval';

const TermApprovalSample = {
  'id': 15851465,
  'name': null,
  'dealId': 5055622,
  'calculationType': 'term',
  'stability': 'hard',
  'termType': 'months',
  'expires': '2025-01-28 00:00:00',
  'position': 1,
  'netMinimum': 79,
  'pointsTradable': 0,
  'payoffAmount': 0,
  'withheldAmount': 0,
  'notes': '[ApprovalSeeder] This is a test approval',
  'offerLink': 'https://lendersite.example/offers/23138291',
  'hasVariablePayment': null,
  'isTest': 0,
  'publishedToBorrower': null,
  'publishedByLenderUserId': null,
  'created': '2025-01-27 13:44:11',
  'modified': '2025-01-27 13:44:11',
  'deleted': null,
  'options': [
    {
      'id': 7608,
      'approvalId': 15851465,
      'term': 17,
      'paymentFrequency': 'weekly',
      'lenderOptionId': '16e689ef-456d-30e1-8e04-283e61532e24',
      'periodicRate': 0.1299,
      'payments': 72,
      'originationFeePercent': 3,
      'daysInPeriod': '7.00000000',
      'periodsPerYear': 52,
      'created': '2025-01-27 13:44:11',
      'modified': '2025-01-27 13:44:11',
      'deleted': null,
      'customCalculatorParams': null,
      'limits': {
        'amount': {
          'min': 5000,
          'max': 50000
        },
        'points': {
          'min': 1,
          'max': 3
        },
        'originationFeeAmount': {
          'min': 0,
          'max': 0
        }
      },
      'createdTimestamp': 1738010651,
      'modifiedTimestamp': 1738010651
    }
  ],
  'loanProductName': 'Business Term Loan',
  'loanProductRoundingStrategy': 'halfEven',
  'loanProductLenderId': 47800,
  'loanProductId': 1658,
  'calculatorConfig': {
    'drawFeeAmount': 'DEFAULT',
    'disbursement': 'DEFAULT',
    'annualInterestRate': 'DEFAULT',
    'payback': 'DEFAULT',
    'totalInterest': 'DEFAULT',
    'totalCostOfCapital': 'DEFAULT',
    'apr': 'DEFAULT',
    'centsOnTheDollar': 'DEFAULT',
    'paymentSchedule': {
      'scheduleRowPaymentAmount': 'DEFAULT',
      'scheduleRowInterestAmount': 'DEFAULT',
      'scheduleRowPrincipalAmount': 'DEFAULT',
      'scheduleRowEndBalance': 'DEFAULT'
    },
    'buyRate': 'DEFAULT'
  },
  'benefits': [],
  'loanProductLender': 'CCBank',
  'loanProductType': 'traditional',
  'requestNames': {
    'nonConditional': [
      'Voided Check - voided check needed',
      'Driver\'s License - driver\'s license needed',
      'Valid Phone Number - Valid Phone Number',
      'Alternative Phone Number - Alternative Phone Number',
      'Use of funds',
      'Voided Check - Please upload a voided check from your business bank account.',
      'Driver’s License - Please upload a copy of your driver\'s license.',
      'Proof of Business Address (Recent Business Utility Bill, Current Business License, or Executed Business Lease)',
      'Bank Verification',
      'Tax Return - Business Tax Return document for specified year.'
    ],
    'conditional': []
  },
  'loanProductCategoryType': 'term'
};

export const TermFunctionalApprovalSample = new FunctionalApproval(TermApprovalSample as unknown as Approval);
